import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FormCategory, FormStatus, FormSummary, Tag, TagSetting } from '../../../../core';
export var FormSummaryApiMapper = /*#__PURE__*/function () {
  function FormSummaryApiMapper() {
    _classCallCheck(this, FormSummaryApiMapper);
  }

  _createClass(FormSummaryApiMapper, [{
    key: "toDomain",
    value: function toDomain(formDto) {
      var props = {
        id: formDto.id,
        title: formDto.title,
        folderId: formDto.folderId,
        updatedAt: formDto === null || formDto === void 0 ? void 0 : formDto.updatedAt,
        status: FormStatus.Active,
        createdBy: formDto.createdBy,
        type: formDto.type,
        description: formDto.description,
        thumbnail: formDto.thumbnail,
        coverImage: formDto.coverImage,
        totalQuestions: formDto.totalQuestions
      };

      if (formDto.category) {
        props.category = FormCategory.create({
          id: formDto.category.id,
          key: formDto.category.key,
          status: formDto.category.status,
          possibleQuestionCreationTypes: formDto.category.possibleQuestionCreationTypes,
          tagSettings: formDto.category.tagSettings ? formDto.category.tagSettings.map(function (tag) {
            return TagSetting.create(_objectSpread({}, tag)).getValue();
          }) : []
        }).getValue();
      }

      if (formDto.tags) {
        props.tags = formDto.tags.map(function (t) {
          return t && Tag.create({
            id: t.id,
            key: t.key
          }).getValue();
        }).filter(function (tag) {
          return !!tag;
        });
      }

      return FormSummary.create(props).getValue();
    }
  }]);

  return FormSummaryApiMapper;
}();